import { render, staticRenderFns } from "./RederAIFm.vue?vue&type=template&id=e2d8a1fa&scoped=true"
import script from "./RederAIFm.vue?vue&type=script&lang=js"
export * from "./RederAIFm.vue?vue&type=script&lang=js"
import style0 from "./RederAIFm.vue?vue&type=style&index=0&id=e2d8a1fa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../.yarn/__virtual__/vue-loader-virtual-45869d479f/4/.yarn/berry/cache/vue-loader-npm-15.11.1-829412283a-10c0.zip/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2d8a1fa",
  null
  
)

export default component.exports